/* eslint-disable unicorn/prefer-module */
/* eslint-disable no-console */
/* eslint-disable indent */
import { useEffect, useCallback, useState, useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import toast from "react-hot-toast";
import { FaEdit, FaTrash } from "react-icons/fa";
import { TiFlash } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Collapse } from "reactstrap";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, LabelList } from "recharts";
import { useAuthContext } from "../../context/auth";
import {
  getCategorias,
  getContratos,
  getOportunidades,
  updateContrato,
  updateOportunidad,
  getUsers,
  getIntermediarios,
  getEdificiosOperativos,
  getClientes,
  getOportunidadesBTL,
  updateOportunidadBTL,
} from "../../utils";
import { getConvertedImporte, getConvertedImporteBTL } from "../../utils/calculateVentas";
import { AgenciasDropdown, matchAgenciaFilter } from "../AgenciasDropdown";
import { Header } from "../Header";
import "./stylesVentasDetalle.scss";
import styles from "./VentasDetalle.module.scss";

export const VentasDetalle = () => {
  const [categorias, setCategorias] = useState([]);
  const [deletedOpportunity, setDeletedOpportunity] = useState(null);
  const [editingOpportunity, setEditingOpportunity] = useState(null);
  const [filtroAnoCierre, setFiltroAnoCierre] = useState(["2026"]);
  const [filtroAnoFactura, setFiltroAnoFactura] = useState(["2026"]);
  const [filtroCategoria, setFiltroCategoria] = useState("");
  const [filtroCliente, setFiltroCliente] = useState("");
  const [filtroEjecutivo, setFiltroEjecutivo] = useState("");
  const [filtroEstatus, setFiltroEstatus] = useState([]);
  const [filtroIntermediario, setFiltroIntermediario] = useState("");
  const [filtroMes, setFiltroMes] = useState([]);
  const [intermediaryMap, setIntermediaryMap] = useState({});
  const [intermediarios, setIntermediarios] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [oportunidades, setOportunidades] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [edificios, setEdificios] = useState([]);
  const [isBuildingsExpanded, setIsBuildingsExpanded] = useState(false);
  const [oportunidadesBTL, setOportunidadesBTL] = useState([]);
  const [contratos, setContratos] = useState([]);
  const [filtroMesCierre, setFiltroMesCierre] = useState([]);
  const [flashEditingOpportunity, setFlashEditingOpportunity] = useState(null);
  const [isFlashEditing, setIsFlashEditing] = useState(false);
  const [filtroProducto, setFiltroProducto] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const methods = useForm();
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = methods;
  const { pais, id } = useAuthContext();

  const localString = useCallback(
    (pais) =>
      ({
        Chile: "es-CL",
        Perú: "es-PE",
        Uruguay: "es-UY",
        Region: "es-US",
      })[pais] || "es-UY",
    []
  );

  const moneda = useCallback(
    (pais) =>
      ({
        Chile: "$",
        Perú: "S/",
        Uruguay: "$",
      })[pais] || "$",
    []
  );

  const decimales = useCallback(
    (pais) =>
      ({
        Chile: 0,
        Perú: 2,
        Uruguay: 0,
      })[pais] || 0,
    []
  );

  const tiposDeCambio = {
    Uruguay: 40,
    Perú: 3.75,
    Chile: 950,
  };
  const rate = tiposDeCambio[pais] || 1;

  const mesEnLetras = useCallback((mes) => {
    const mesesEnLetras = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    return mesesEnLetras[parseInt(mes) - 1] || "-";
  }, []);

  const isEditableByDate = (createdAt) => {
    const today = new Date("2025-04-19");
    const createdDate = new Date(createdAt);
    return !isNaN(createdDate) && createdDate >= today;
  };

  const navigate = useNavigate();

  const handleMesChange = useCallback((e) => {
    const selectedMonths = Array.from(
      e.target.closest(".dropdown-menu").querySelectorAll("input[type=checkbox]:checked"),
      (checkbox) => checkbox.value
    );
    setFiltroMes(selectedMonths);
  }, []);

  const handleMesCierreChange = useCallback((e) => {
    const selectedMonths = Array.from(
      e.target.closest(".dropdown-menu").querySelectorAll("input[type=checkbox]:checked"),
      (checkbox) => checkbox.value
    );
    setFiltroMesCierre(selectedMonths);
  }, []);

  const renderMesOptions = (filtro, onChangeHandler) =>
    ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"].map((mes, index) => (
      <div key={index} className="form-check left-aligned-checkbox">
        <input
          className="form-check-input"
          type="checkbox"
          id={`mes${filtro === filtroMes ? "factura" : "cierre"}${index}`}
          value={index < 9 ? `0${index + 1}` : `${index + 1}`}
          checked={filtro.includes(index < 9 ? `0${index + 1}` : `${index + 1}`)}
          onChange={onChangeHandler}
        />
        <label className="form-check-label" htmlFor={`mes${filtro === filtroMes ? "factura" : "cierre"}${index}`}>
          {mes}
        </label>
      </div>
    ));

  const renderClientesOptions = () => {
    const uniqueEmpresas = [
      ...new Set(
        clientes
          .filter((cliente) => cliente.pais === pais)
          .map((cliente) => cliente.empresa)
          .filter((empresa) => empresa)
      ),
    ].sort((a, b) => a.localeCompare(b));
    return uniqueEmpresas.map((empresa, index) => (
      <option key={index} value={empresa}>
        {empresa}
      </option>
    ));
  };

  const renderProductosOptions = () => {
    const uniqueProductos = [
      ...new Set(
        clientes
          .filter((cliente) => cliente.pais === pais)
          .map((cliente) => cliente.producto)
          .filter((producto) => producto)
      ),
    ].sort((a, b) => a.localeCompare(b));
    return uniqueProductos.map((producto, index) => (
      <option key={index} value={producto}>
        {producto}
      </option>
    ));
  };

  const clienteCategoriaMap = useMemo(() => {
    const map = {};
    clientes.forEach((cliente) => {
      const categoria = categorias.find((cat) => cat.id.toString() === cliente.categoria.toString());
      map[cliente.id] = categoria ? categoria.nombre : "";
    });
    return map;
  }, [clientes, categorias]);

  const clienteIntermediarioMap = useMemo(() => {
    const map = {};
    clientes.forEach((cliente) => {
      map[cliente.id] = cliente.agencia;
    });
    return map;
  }, [clientes]);

  const handleEstatusChange = (e) => {
    const value = e.target.value;
    setFiltroEstatus((prev) => (prev.includes(value) ? prev.filter((estatus) => estatus !== value) : [...prev, value]));
  };

  const renderEstatusOptions = () =>
    Object.entries({ "100%": 0, "90%": 1, "75%": 2, "50%": 3, "0%": 4 }).map(([estatus, _], index) => (
      <div key={index} className="form-check left-aligned-checkbox">
        <input
          className="form-check-input"
          type="checkbox"
          id={`estatus${index}`}
          value={estatus}
          checked={filtroEstatus.includes(estatus)}
          onChange={handleEstatusChange}
        />
        <label className="form-check-label" htmlFor={`estatus${index}`}>
          {estatus}
        </label>
      </div>
    ));

  const handleEdit = (oportunidad) => {
    if (
      oportunidad.facturanumero ||
      oportunidad.estatus === "0%" ||
      (pais === "Chile" && id.toString() !== oportunidad.ejecutivoId.toString())
    ) {
      toast.error("No tienes permiso para editar esta oportunidad.");
      return;
    }
    if (oportunidad.type === "btl") {
      toast.info("La edición de oportunidades BTL está en desarrollo.");
      return;
    }
    if (pais === "Perú" || pais === "Chile") {
      if (isEditableByDate(oportunidad.created_at)) {
        navigate(`/admin/online-cotizador/editar/${oportunidad.id}`, { state: { oportunidad } });
      } else {
        setEditingOpportunity(oportunidad);
        setIsEditing(true);
      }
    } else {
      console.warn("Edición no soportada para el país:", pais);
      toast.info("Edición no disponible para este país.");
    }
  };

  const onSubmitEdit = async (data) => {
    try {
      setLoading(true);
      const updatedOportunidad = {
        estatus: data.estatus,
        mes_cierre: data.mes_cierre,
        mes: data.mes,
        updated_at: new Date().toISOString(),
      };
      await updateOportunidad({ id: editingOpportunity.id, oportunidad: updatedOportunidad });
      toast.success("Oportunidad actualizada correctamente");
      setOportunidades((prev) =>
        prev.map((op) => (op.id === editingOpportunity.id ? { ...op, ...updatedOportunidad } : op))
      );
      setIsEditing(false);
      setEditingOpportunity(null);
    } catch (error) {
      console.error("Error updating oportunidad:", error);
      toast.error("Error al actualizar la oportunidad");
    } finally {
      setLoading(false);
    }
  };

  const months = [
    { value: "01", label: "ENE" },
    { value: "02", label: "FEB" },
    { value: "03", label: "MAR" },
    { value: "04", label: "ABR" },
    { value: "05", label: "MAY" },
    { value: "06", label: "JUN" },
    { value: "07", label: "JUL" },
    { value: "08", label: "AGO" },
    { value: "09", label: "SEP" },
    { value: "10", label: "OCT" },
    { value: "11", label: "NOV" },
    { value: "12", label: "DIC" },
  ];

  const handleDelete = async (id, type) => {
    try {
      setLoading(true);
      if (type === "btl") {
        await updateOportunidadBTL({ id, oportunidad: { eliminada: true } });
        setOportunidadesBTL((prev) => prev.map((op) => (op.full_id === id ? { ...op, eliminada: true } : op)));
      } else if (type === "contrato") {
        await updateContrato({ id, contrato: { eliminada: true } });
        setContratos((prev) => prev.map((op) => (op.id === id ? { ...op, eliminada: true } : op)));
      } else {
        await updateOportunidad({ id, oportunidad: { eliminada: true } });
        setOportunidades((prev) => prev.map((op) => (op.id === id ? { ...op, eliminada: true } : op)));
      }
      toast.success(
        type === "contrato" ? "El contrato se eliminó correctamente" : "La oportunidad se eliminó correctamente"
      );
      setShowConfirmationModal(false);
      setDeletedOpportunity(null);
    } catch (error) {
      console.error("Error deleting oportunidad:", error);
      toast.error("Hubo un error al eliminar, prueba de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmationModal = (oportunidad) => {
    setShowConfirmationModal(true);
    setDeletedOpportunity(oportunidad);
  };

  useEffect(() => {
    const fetchIntermediaries = async () => {
      try {
        const fetchedIntermediarios = await getIntermediarios({ pais });
        const map = fetchedIntermediarios.reduce((acc, inter) => {
          acc[inter.id] = inter.nombre;
          return acc;
        }, {});
        setIntermediaryMap(map);
        setIntermediarios(fetchedIntermediarios);
      } catch (error) {
        console.error("Error fetching intermediaries:", error);
      }
    };
    fetchIntermediaries();
  }, [pais]);

  useEffect(() => {
    if (editingOpportunity) {
      methods.reset({
        estatus: editingOpportunity.estatus || "",
        mes_cierre: editingOpportunity.mes_cierre || "01",
        mes: editingOpportunity.mes || "01",
      });
    }
  }, [editingOpportunity, methods]);

  const fetchData = useCallback(async () => {
    try {
      const normalizeMonthLocal = (month, ano, created_at, fallbackMonth = null) => {
        if (!month && !fallbackMonth) return null;
        const monthValue = month || fallbackMonth;
        const monthStr = monthValue.toString().trim();
        if (/^\d{2}-\d{4}$/.test(monthStr)) return monthStr;
        if (/^\d{4}-\d{2}-\d{2}$/.test(monthStr)) {
          return `${monthStr.slice(5, 7)}-${monthStr.slice(0, 4)}`;
        }
        const monthNum = parseInt(monthStr, 10);
        if (isNaN(monthNum) || monthNum < 1 || monthNum > 12) return null;
        const paddedMonth = monthNum.toString().padStart(2, "0");
        const year = ano ? ano.toString() : new Date(created_at).getFullYear().toString();
        return `${paddedMonth}-${year}`;
      };

      // 1. CARGAR CLIENTES PRIMERO (crucial)
      const fetchedClientes = await getClientes({ pais });
      const fetchedUsers = getUsers();
      const newOportunidadesRaw = getOportunidades({ pais });
      const newOportunidadesBTLRaw = getOportunidadesBTL({ pais: pais });
      const newContratosRaw = getContratos({ pais });

      const [clientesData, usersData, oportunidadesData, btlData, contratosData] = await Promise.all([
        fetchedClientes,
        fetchedUsers,
        newOportunidadesRaw,
        newOportunidadesBTLRaw,
        newContratosRaw,
      ]);

      setClientes(clientesData || []);
      setUsers(usersData || []);

      // 2. AHORA SÍ procesar oportunidades normales
      const mappedOportunidades = oportunidadesData.map((oportunidad) => {
        const ejecutivoName = (() => {
          const user = usersData.find((u) => String(u.id) === String(oportunidad.ejecutivo));
          return user
            ? user.nombre
            : typeof oportunidad.ejecutivo === "string"
              ? oportunidad.ejecutivo.split(" ")[0]
              : "Sin asignar";
        })();

        const normalizedMesCierre = normalizeMonthLocal(
          oportunidad.mes_cierre,
          oportunidad.ano || oportunidad.ano_cierre,
          oportunidad.created_at,
          oportunidad.mes_cierre_old || oportunidad.mes_old
        );

        const normalizedMesFactura = normalizeMonthLocal(
          oportunidad.mes_factura,
          oportunidad.ano || oportunidad.ano_cierre,
          oportunidad.created_at,
          oportunidad.mes_old || oportunidad.mes_cierre_old
        );

        const anoOportunidad =
          normalizedMesCierre?.split("-")?.[1] ||
          normalizedMesFactura?.split("-")?.[1] ||
          new Date(oportunidad.created_at).getFullYear().toString();

        return {
          ...oportunidad,
          ejecutivoId: oportunidad.ejecutivo,
          ejecutivo: ejecutivoName,
          mes_cierre: normalizedMesCierre,
          mes_factura: normalizedMesFactura,
          estatus: oportunidad.estatus || (oportunidad.status ? `${oportunidad.status}%` : "0%"),
          ano: anoOportunidad,
        };
      });
      setOportunidades(mappedOportunidades);

      // 3. AHORA SÍ procesar BTL (con clientes ya cargados)
      const mappedBTL = btlData
        .filter((btl) => !btl.eliminada && btl.pais === pais)
        .map((btl) => {
          const clienteEmpresa =
            clientesData.find((c) => String(c.id) === String(btl.client_id))?.empresa || "Cliente no encontrado";
          const ejecutivo = usersData.find((u) => String(u.id) === String(btl.executive_responsible || btl.created_by));
          const ejecutivoName = ejecutivo ? ejecutivo.nombre : "Sin asignar";
          return {
            ...btl,
            id: btl.numeric_id.toString(),
            full_id: btl.id,
            type: "btl",
            cliente: clienteEmpresa,
            ejecutivo: ejecutivoName,
            ejecutivoId: btl.executive_responsible || btl.created_by,
            mes_cierre: btl.mes_cierre || null,
            mes_factura: btl.mes_factura || null,
            estatus: btl.status ? `${btl.status}%` : "75%",
            ano: btl.mes_cierre?.split("-")[1] || "2025",
            facturanumero: btl.facturanumero,
            facturafecha: btl.facturafecha,
          };
        });

      setOportunidadesBTL(mappedBTL);

      // 4. Procesar contratos multi-mes
      const mappedContratos = (contratosData || [])
        .filter((c) => !c.eliminada && c.pais === pais)
        .map((c) => {
          const clienteEmpresa =
            clientesData.find((cl) => String(cl.id) === String(c.client_id))?.empresa || c.cliente || "Sin cliente";
          const ejecutivo = usersData.find((u) => String(u.id) === String(c.ejecutivo));
          const ejecutivoName = ejecutivo ? ejecutivo.nombre : "Sin asignar";
          return {
            ...c,
            type: "contrato",
            cliente: clienteEmpresa,
            ejecutivo: ejecutivoName,
            ejecutivoId: c.ejecutivo,
            importe: c.importe_total,
            mes_factura: c.mes_inicio,
            estatus: c.estatus || "50%",
            ano: c.ano?.toString() || c.mes_inicio?.split("-")[1] || "2026",
          };
        });
      setContratos(mappedContratos);

      // resto de cargas (categorías, edificios, etc.)
      const newCategorias = await getCategorias();
      setCategorias(newCategorias);
      const fetchedEdificios = await getEdificiosOperativos({ pais });
      setEdificios(fetchedEdificios || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Error al cargar datos");
    }
  }, [pais]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (flashEditingOpportunity) {
      methods.reset({
        estatus: flashEditingOpportunity.estatus || "",
        mes_cierre: flashEditingOpportunity?.mes_cierre ? flashEditingOpportunity.mes_cierre.split("-")[0] : "01",
        ano_cierre: flashEditingOpportunity?.mes_cierre ? flashEditingOpportunity.mes_cierre.split("-")[1] : "2025",
        mes_factura: flashEditingOpportunity?.mes_factura ? flashEditingOpportunity.mes_factura.split("-")[0] : "01",
        ano_factura: flashEditingOpportunity?.mes_factura ? flashEditingOpportunity.mes_factura.split("-")[1] : "2025",
      });
    }
  }, [flashEditingOpportunity, methods]);

  const renderCategoriaOptions = () =>
    Array.isArray(categorias)
      ? categorias.map((categoria, index) => (
          <option key={index} value={categoria.nombre}>
            {categoria.nombre}
          </option>
        ))
      : [];

  const handleCategoriaChange = (e) => setFiltroCategoria(e.target.value);

  const handleAnoCierreChange = (e) => {
    const value = e.target.value;
    setFiltroAnoCierre((prev) => (prev.includes(value) ? prev.filter((ano) => ano !== value) : [...prev, value]));
  };

  const handleAnoFacturaChange = (e) => {
    const value = e.target.value;
    setFiltroAnoFactura((prev) => (prev.includes(value) ? prev.filter((ano) => ano !== value) : [...prev, value]));
  };

  const handleFlashEdit = (oportunidad) => {
    if (
      oportunidad.facturanumero ||
      oportunidad.estatus === "0%" ||
      (pais === "Chile" && id.toString() !== String(oportunidad.ejecutivoId || ""))
    ) {
      toast.error("No tienes permiso para editar esta oportunidad.");
      return;
    }
    if (oportunidad.type === "btl") {
      toast.info("La edición de oportunidades BTL está en desarrollo.");
      return;
    }
    // Contratos: solo editar status y cierre (no factura, ya que es un rango)
    setFlashEditingOpportunity(oportunidad);
    setIsFlashEditing(true);
  };

  const onSubmitFlashEdit = async (data) => {
    try {
      // Validar que facturación no sea anterior a cierre (solo para oportunidades, no contratos)
      if (flashEditingOpportunity.type !== "contrato") {
        const cierreDate = parseInt(data.ano_cierre) * 12 + parseInt(data.mes_cierre);
        const facturaDate = parseInt(data.ano_factura) * 12 + parseInt(data.mes_factura);
        if (facturaDate < cierreDate) {
          toast.error("El mes de facturación no puede ser anterior al mes de cierre");
          return;
        }
      }

      setLoading(true);

      if (flashEditingOpportunity.type === "contrato") {
        // Contratos: actualizar estatus y cierre
        const updatedContrato = {
          estatus: data.estatus,
          mes_cierre: `${data.mes_cierre.padStart(2, "0")}-${data.ano_cierre}`,
          updated_at: new Date().toISOString(),
        };
        await updateContrato({ id: flashEditingOpportunity.id, contrato: updatedContrato });
        toast.success("Contrato actualizado correctamente");
        setContratos((prev) =>
          prev.map((op) => (op.id === flashEditingOpportunity.id ? { ...op, ...updatedContrato } : op))
        );
      } else {
        const updatedOportunidad = {
          estatus: data.estatus,
          mes_cierre: `${data.mes_cierre.padStart(2, "0")}-${data.ano_cierre}`,
          mes_factura: `${data.mes_factura.padStart(2, "0")}-${data.ano_factura}`,
          updated_at: new Date().toISOString(),
        };
        await updateOportunidad({ id: flashEditingOpportunity.id, oportunidad: updatedOportunidad });
        toast.success("Oportunidad actualizada correctamente");
        setOportunidades((prev) =>
          prev.map((op) => (op.id === flashEditingOpportunity.id ? { ...op, ...updatedOportunidad } : op))
        );
      }
      setIsFlashEditing(false);
      setFlashEditingOpportunity(null);
    } catch (error) {
      console.error("Error updating oportunidad:", error);
      toast.error("Error al actualizar la oportunidad");
    } finally {
      setLoading(false);
    }
  };

  const getRadius = (key, data) => {
    const keys = Object.keys(data).filter((k) => data[k] > 0);
    const firstKey = keys[0];
    const lastKey = keys.at(-1);
    if (firstKey === key && lastKey === key) return [10, 10, 10, 10];
    if (firstKey === key) return [10, 0, 0, 10];
    if (lastKey === key) return [0, 10, 10, 0];
    return [0, 0, 0, 0];
  };

  const customStatusOrder = { "100%": 0, "90%": 1, "75%": 2, "50%": 3, "0%": 4 };

  const oportunidadesFiltradas = [...oportunidades, ...oportunidadesBTL, ...contratos].filter((oportunidad) => {
    const cliente = clientes.find((c) => c.id === oportunidad.client_id && c.pais === pais);
    const clienteMatch = !filtroCliente || (cliente && cliente.empresa === filtroCliente);
    const productoMatch = !filtroProducto || (cliente && cliente.producto === filtroProducto);

    // Extraer mes y año de cierre de la oportunidad
    const mesCierreOportunidad = oportunidad.mes_cierre ? oportunidad.mes_cierre.split("-")[0] : null;
    const anoCierreOportunidad = oportunidad.mes_cierre ? oportunidad.mes_cierre.split("-")[1] : null;

    // Filtro combinado de cierre: mes Y año deben coincidir cuando ambos están seleccionados
    const cierreMatch = (() => {
      const hayFiltroMes = filtroMesCierre.length > 0;
      const hayFiltroAno = filtroAnoCierre.length > 0;
      if (!hayFiltroMes && !hayFiltroAno) return true;
      if (!mesCierreOportunidad || !anoCierreOportunidad) return false;
      const mesCoincide = !hayFiltroMes || filtroMesCierre.includes(mesCierreOportunidad);
      const anoCoincide = !hayFiltroAno || filtroAnoCierre.includes(anoCierreOportunidad);
      return mesCoincide && anoCoincide;
    })();

    // Extraer mes y año de factura de la oportunidad
    const mesFacturaOportunidad = oportunidad.facturafecha
      ? String(new Date(oportunidad.facturafecha).getMonth() + 1).padStart(2, "0")
      : oportunidad.mes_factura
        ? oportunidad.mes_factura.split("-")[0]
        : null;
    const anoFacturaOportunidad = oportunidad.facturafecha
      ? new Date(oportunidad.facturafecha).getFullYear().toString()
      : oportunidad.mes_factura
        ? oportunidad.mes_factura.split("-")[1]
        : null;

    // Filtro combinado de factura: mes Y año deben coincidir cuando ambos están seleccionados
    const facturaMatch = (() => {
      const hayFiltroMes = filtroMes.length > 0;
      const hayFiltroAno = filtroAnoFactura.length > 0;
      if (!hayFiltroMes && !hayFiltroAno) return true;
      if (!mesFacturaOportunidad || !anoFacturaOportunidad) return false;
      const mesCoincide = !hayFiltroMes || filtroMes.includes(mesFacturaOportunidad);
      const anoCoincide = !hayFiltroAno || filtroAnoFactura.includes(anoFacturaOportunidad);
      return mesCoincide && anoCoincide;
    })();

    const estatusMatch = filtroEstatus.length === 0 || filtroEstatus.includes(oportunidad.estatus);
    const categoriaMatch = !filtroCategoria || clienteCategoriaMap[oportunidad.client_id] === filtroCategoria;
    const ejecutivoMatch = !filtroEjecutivo || oportunidad.ejecutivoId.toString() === filtroEjecutivo.toString();
    const intermediaryId = clienteIntermediarioMap[oportunidad.client_id] || null;
    const intermediarioMatch = matchAgenciaFilter(filtroIntermediario, intermediaryId, pais);
    return (
      clienteMatch &&
      productoMatch &&
      cierreMatch &&
      facturaMatch &&
      estatusMatch &&
      intermediarioMatch &&
      categoriaMatch &&
      ejecutivoMatch &&
      !oportunidad.eliminada
    );
  });

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const parseMesAno = (mesAnoStr) => {
    if (!mesAnoStr || typeof mesAnoStr !== "string") return 0;
    const parts = mesAnoStr.split("-");
    if (parts.length !== 2) return 0;
    const mes = parseInt(parts[0], 10);
    const ano = parseInt(parts[1], 10);
    return ano * 12 + mes;
  };

  const sortedOportunidades = [...oportunidadesFiltradas].sort((a, b) => {
    // Si hay un sortConfig activo, usarlo
    if (sortConfig.key) {
      const direction = sortConfig.direction === "asc" ? 1 : -1;

      switch (sortConfig.key) {
        case "id":
          return direction * (parseInt(a.id) - parseInt(b.id));
        case "cliente":
          return direction * (a.cliente || "").localeCompare(b.cliente || "");
        case "campana":
          return direction * (a.campana || "").localeCompare(b.campana || "");
        case "cierre": {
          const cierreA = parseMesAno(a.mes_cierre);
          const cierreB = parseMesAno(b.mes_cierre);
          return direction * (cierreA - cierreB);
        }
        case "factura": {
          const facturaA = a.facturafecha
            ? new Date(a.facturafecha).getTime()
            : parseMesAno(a.mes_factura) * 2629800000;
          const facturaB = b.facturafecha
            ? new Date(b.facturafecha).getTime()
            : parseMesAno(b.mes_factura) * 2629800000;
          return direction * (facturaA - facturaB);
        }
        case "ticket": {
          const importeA = a.type === "btl" ? getConvertedImporteBTL(a, rate) : getConvertedImporte(a, rate);
          const importeB = b.type === "btl" ? getConvertedImporteBTL(b, rate) : getConvertedImporte(b, rate);
          return direction * (importeA - importeB);
        }
        case "status": {
          const statusA = customStatusOrder[a.estatus || "0%"];
          const statusB = customStatusOrder[b.estatus || "0%"];
          return direction * (statusA - statusB);
        }
        case "ejecutivo":
          return direction * (a.ejecutivo || "").localeCompare(b.ejecutivo || "");
        default:
          break;
      }
    }

    // Ordenamiento por defecto (status > mes > importe)
    const statusA = customStatusOrder[a.estatus || "0%"];
    const statusB = customStatusOrder[b.estatus || "0%"];
    if (statusA !== statusB) {
      return statusA - statusB;
    }
    const mesA = parseInt(a.mes || "01");
    const mesB = parseInt(b.mes || "01");
    if (mesA !== mesB) {
      return mesA - mesB;
    }
    const importeA = a.type === "btl" ? getConvertedImporteBTL(a, rate) : getConvertedImporte(a, rate);
    const importeB = b.type === "btl" ? getConvertedImporteBTL(b, rate) : getConvertedImporte(b, rate);
    return importeB - importeA;
  });

  const renderEjecutivosOptions = () => {
    const countryMapping = { Uruguay: "URU", Perú: "PER", Chile: "CHI" };
    const countryCode = countryMapping[pais] || "";
    const ejecutivosUnicos = users
      .filter((user) => {
        const userPais = user.pais || "";
        const userRol = user.rol ? user.rol.toLowerCase().trim() : "";
        const validRoles = ["comercial", "gerencia"].map((r) => r.toLowerCase());
        return (userPais === countryCode || !countryCode) && validRoles.includes(userRol) && user.habilitado === true;
      })
      .sort((a, b) => `${a.nombre} ${a.apellido}`.localeCompare(`${b.nombre} ${b.apellido}`));
    return ejecutivosUnicos.map((user, index) => (
      <option key={index} value={user.id}>
        {`${user.nombre} ${user.apellido}`}
      </option>
    ));
  };

  // eslint-disable-next-line no-unused-vars
  const handleShowDetails = (oportunidad) => {
    setSelectedOpportunity(oportunidad);
    setShowDetailsModal(true);
  };

  const toggleBuildingsList = () => {
    setIsBuildingsExpanded(!isBuildingsExpanded);
  };

  const salesData = useMemo(() => {
    // Usamos exactamente las oportunidades que ya están filtradas y ordenadas para la tabla
    const oportunidadesVisibles = sortedOportunidades;

    // Helper: para mismo client_id con múltiples oportunidades, tomar solo la de menor valor
    const getMinByClient = (ops) => {
      const byClient = {};
      ops.forEach((op) => {
        const clientId = op.client_id || op.cliente;
        const importe = op.type === "btl" ? getConvertedImporteBTL(op, rate) : getConvertedImporte(op, rate);
        if (!byClient[clientId] || importe < byClient[clientId]) {
          byClient[clientId] = importe;
        }
      });
      return Object.values(byClient).reduce((sum, val) => sum + val, 0);
    };

    // Filtrar por estatus
    const ops100 = oportunidadesVisibles.filter((op) => op.estatus === "100%");
    const ops90 = oportunidadesVisibles.filter((op) => op.estatus === "90%");
    const ops75 = oportunidadesVisibles.filter((op) => op.estatus === "75%");
    const ops50 = oportunidadesVisibles.filter((op) => op.estatus === "50%");
    const ops0 = oportunidadesVisibles.filter((op) => op.estatus === "0%");

    // 100% suma todo (ya cerrado), 90%/75% aplica deduplicación por cliente
    const suma100 = ops100.reduce(
      (acc, op) => acc + (op.type === "btl" ? getConvertedImporteBTL(op, rate) : getConvertedImporte(op, rate)),
      0
    );
    const suma90 = getMinByClient(ops90);
    const suma75 = getMinByClient(ops75);
    const suma50 = ops50.reduce(
      (acc, op) => acc + (op.type === "btl" ? getConvertedImporteBTL(op, rate) : getConvertedImporte(op, rate)),
      0
    );
    const suma0 = ops0.reduce(
      (acc, op) => acc + (op.type === "btl" ? getConvertedImporteBTL(op, rate) : getConvertedImporte(op, rate)),
      0
    );

    const total = suma100 + suma90 + suma75 + suma50 + suma0;

    return {
      sumaImportes100: Math.round(suma100),
      sumaImportes90: Math.round(suma90),
      sumaImportes75: Math.round(suma75),
      sumaImportes50: Math.round(suma50),
      sumaImportes0: Math.round(suma0),
      chartData: [
        {
          name: "Total",
          "100%": total ? (suma100 / total) * 100 : 0,
          "90%": total ? (suma90 / total) * 100 : 0,
          "75%": total ? (suma75 / total) * 100 : 0,
          "50%": total ? (suma50 / total) * 100 : 0,
          "0%": total ? (suma0 / total) * 100 : 0,
          empty: total === 0 ? 100 : 0,
        },
      ],
    };
  }, [sortedOportunidades, rate, pais]);

  return (
    <div className="container-ventas-detalle">
      <Header expandChildren>
        <div className={styles.filtersContainer}>
          {/* Fila 1: Empresa, Producto, Categoría, Agencia, Ejecutivo */}
          <div className={styles.filterRow}>
            <div>
              <select
                className={`form-control ${filtroCliente ? styles.activeFilter : ""}`}
                value={filtroCliente}
                onChange={(e) => setFiltroCliente(e.target.value)}
              >
                <option value="">Empresa</option>
                {renderClientesOptions()}
              </select>
            </div>
            <div>
              <select
                className={`form-control ${filtroProducto ? styles.activeFilter : ""}`}
                value={filtroProducto}
                onChange={(e) => setFiltroProducto(e.target.value)}
              >
                <option value="">Producto</option>
                {renderProductosOptions()}
              </select>
            </div>
            <div>
              <select
                className={`form-control ${filtroCategoria ? styles.activeFilter : ""}`}
                value={filtroCategoria}
                onChange={handleCategoriaChange}
              >
                <option value="">Categoría</option>
                {renderCategoriaOptions()}
              </select>
            </div>
            <div>
              <AgenciasDropdown
                value={filtroIntermediario}
                onChange={(e) => setFiltroIntermediario(e.target.value)}
                intermediarios={intermediarios}
                placeholder="Agencia"
                className={`form-control ${filtroIntermediario ? styles.activeFilter : ""}`}
              />
            </div>
            <div>
              <select
                className={`form-control ${filtroEjecutivo ? styles.activeFilter : ""}`}
                value={filtroEjecutivo}
                onChange={(e) => setFiltroEjecutivo(e.target.value)}
              >
                <option value="">Ejecutivo</option>
                {renderEjecutivosOptions()}
              </select>
            </div>
          </div>
          {/* Fila 2: Mes Cierre, Año Cierre, Mes Factura, Año Factura, Status */}
          <div className={styles.filterRow}>
            <div>
              <Dropdown>
                <Dropdown.Toggle
                  variant="white border"
                  id="dropdown-mes-cierre"
                  className={`form-control text-start ${filtroMesCierre.length > 0 ? styles.activeFilter : ""}`}
                >
                  {filtroMesCierre.length === 0
                    ? "Mes cierre"
                    : filtroMesCierre.length >= 4
                      ? "Varios"
                      : filtroMesCierre.map((mes) => mesEnLetras(mes)).join(", ")}
                </Dropdown.Toggle>
                <Dropdown.Menu>{renderMesOptions(filtroMesCierre, handleMesCierreChange)}</Dropdown.Menu>
              </Dropdown>
            </div>
            <div>
              <Dropdown>
                <Dropdown.Toggle
                  variant="white border"
                  id="dropdown-ano-cierre"
                  className={`form-control text-start ${filtroAnoCierre.length > 0 ? styles.activeFilter : ""}`}
                >
                  Año cierre
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {["2023", "2024", "2025", "2026"].map((ano, index) => (
                    <div key={index} className="form-check left-aligned-checkbox">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`anoCierre${index}`}
                        value={ano}
                        checked={filtroAnoCierre.includes(ano)}
                        onChange={handleAnoCierreChange}
                      />
                      <label className="form-check-label" htmlFor={`anoCierre${index}`}>
                        {ano}
                      </label>
                    </div>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div>
              <Dropdown>
                <Dropdown.Toggle
                  variant="white border"
                  id="dropdown-mes-factura"
                  className={`form-control text-start ${filtroMes.length > 0 ? styles.activeFilter : ""}`}
                >
                  {filtroMes.length === 0
                    ? "Mes factura"
                    : filtroMes.length >= 4
                      ? "Varios"
                      : filtroMes.map((mes) => mesEnLetras(mes)).join(", ")}
                </Dropdown.Toggle>
                <Dropdown.Menu>{renderMesOptions(filtroMes, handleMesChange)}</Dropdown.Menu>
              </Dropdown>
            </div>
            <div>
              <Dropdown>
                <Dropdown.Toggle
                  variant="white border"
                  id="dropdown-ano-factura"
                  className={`form-control text-start ${filtroAnoFactura.length > 0 ? styles.activeFilter : ""}`}
                >
                  Año factura
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {["2023", "2024", "2025", "2026"].map((ano, index) => (
                    <div key={index} className="form-check left-aligned-checkbox">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`anoFactura${index}`}
                        value={ano}
                        checked={filtroAnoFactura.includes(ano)}
                        onChange={handleAnoFacturaChange}
                      />
                      <label className="form-check-label" htmlFor={`anoFactura${index}`}>
                        {ano}
                      </label>
                    </div>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div>
              <Dropdown>
                <Dropdown.Toggle
                  variant="white border"
                  id="dropdown-status"
                  className={`form-control text-start ${filtroEstatus.length > 0 ? styles.activeFilter : ""}`}
                >
                  {filtroEstatus.length === 0
                    ? "Status"
                    : filtroEstatus.length >= 4
                      ? "Varios"
                      : filtroEstatus.join(", ")}
                </Dropdown.Toggle>
                <Dropdown.Menu>{renderEstatusOptions()}</Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </Header>
      <div className="row justify-content-center mb-2">
        <div className="col-md-12">
          <div className="d-flex justify-content-between">
            {/* 100% */}
            <div
              className="text-center p-2 bg-success border border-dark m-3 text-white"
              style={{ borderRadius: "4px", width: "225px" }}
            >
              <div>
                <strong>100%</strong>
              </div>
              <div>
                {salesData.sumaImportes100 > 0
                  ? `${moneda(pais)} ${salesData.sumaImportes100.toLocaleString(localString(pais), {
                      maximumFractionDigits: decimales(pais),
                      minimumFractionDigits: decimales(pais),
                    })}`
                  : "-"}
              </div>
            </div>

            {/* 90% */}
            <div
              className="text-center p-2 bg-danger border border-dark m-3 text-white"
              style={{ borderRadius: "4px", width: "225px" }}
            >
              <div>
                <strong>90%</strong>
              </div>
              <div>
                {salesData.sumaImportes90 > 0
                  ? `${moneda(pais)} ${salesData.sumaImportes90.toLocaleString(localString(pais), {
                      maximumFractionDigits: decimales(pais),
                      minimumFractionDigits: decimales(pais),
                    })}`
                  : "-"}
              </div>
            </div>

            {/* 75% */}
            <div
              className="text-center border border-dark p-2 bg-primary m-3 text-white"
              style={{ borderRadius: "4px", width: "225px" }}
            >
              <div>
                <strong>75%</strong>
              </div>
              <div>
                {salesData.sumaImportes75 > 0
                  ? `${moneda(pais)} ${salesData.sumaImportes75.toLocaleString(localString(pais), {
                      maximumFractionDigits: decimales(pais),
                      minimumFractionDigits: decimales(pais),
                    })}`
                  : "-"}
              </div>
            </div>

            {/* 50% */}
            <div
              className="text-center p-2 bg-warning m-3 border border-dark text-dark"
              style={{ borderRadius: "4px", width: "225px" }}
            >
              <div>
                <strong>50%</strong>
              </div>
              <div>
                {salesData.sumaImportes50 > 0
                  ? `${moneda(pais)} ${salesData.sumaImportes50.toLocaleString(localString(pais), {
                      maximumFractionDigits: decimales(pais),
                      minimumFractionDigits: decimales(pais),
                    })}`
                  : "-"}
              </div>
            </div>

            {/* 0% */}
            <div
              className="text-center p-2 bg-black m-3 border border-dark text-white"
              style={{ borderRadius: "4px", width: "225px" }}
            >
              <div>
                <strong>0%</strong>
              </div>
              <div>
                {salesData.sumaImportes0 > 0
                  ? `${moneda(pais)} ${salesData.sumaImportes0.toLocaleString(localString(pais), {
                      maximumFractionDigits: decimales(pais),
                      minimumFractionDigits: decimales(pais),
                    })}`
                  : "-"}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-md-12">
          <ResponsiveContainer width="100%" height={80} className="p-0 m-0">
            <BarChart layout="vertical" data={salesData.chartData} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
              <XAxis type="number" domain={[0, 100]} tick={false} axisLine={false} />
              <YAxis type="category" dataKey="name" hide />

              {/* Acá está el fix: todo chartData → salesData.chartData */}
              {salesData.chartData[0].empty > 0 ? (
                <Bar dataKey="empty" fill="#555555" isAnimationActive={false} radius={[10, 10, 10, 10]}>
                  <LabelList dataKey="empty" position="center" formatter={() => "SIN DATOS"} fill="#FFF" />
                </Bar>
              ) : (
                <>
                  {salesData.chartData[0]["100%"] > 0 && (
                    <Bar dataKey="100%" stackId="a" fill="#198754" radius={getRadius("100%", salesData.chartData[0])}>
                      <LabelList
                        dataKey="100%"
                        position="center"
                        formatter={(value) => `${Math.round(value)}%`}
                        fill="#fff"
                      />
                    </Bar>
                  )}
                  {salesData.chartData[0]["90%"] > 0 && (
                    <Bar dataKey="90%" stackId="a" fill="#dc3545" radius={getRadius("90%", salesData.chartData[0])}>
                      <LabelList
                        dataKey="90%"
                        position="center"
                        formatter={(value) => `${Math.round(value)}%`}
                        fill="#fff"
                      />
                    </Bar>
                  )}
                  {salesData.chartData[0]["75%"] > 0 && (
                    <Bar dataKey="75%" stackId="a" fill="#0d6efd" radius={getRadius("75%", salesData.chartData[0])}>
                      <LabelList
                        dataKey="75%"
                        position="center"
                        formatter={(value) => `${Math.round(value)}%`}
                        fill="#fff"
                      />
                    </Bar>
                  )}
                  {salesData.chartData[0]["50%"] > 0 && (
                    <Bar dataKey="50%" stackId="a" fill="#ffc107" radius={getRadius("50%", salesData.chartData[0])}>
                      <LabelList
                        dataKey="50%"
                        position="center"
                        formatter={(value) => `${Math.round(value)}%`}
                        fill="#000"
                      />
                    </Bar>
                  )}
                  {salesData.chartData[0]["0%"] > 0 && (
                    <Bar dataKey="0%" stackId="a" fill="#000000" radius={getRadius("0%", salesData.chartData[0])}>
                      <LabelList
                        dataKey="0%"
                        position="center"
                        formatter={(value) => `${Math.round(value)}%`}
                        fill="#fff"
                      />
                    </Bar>
                  )}
                </>
              )}
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-md-12">
          <table className="table table-bordered table-striped table-hover table-sm">
            <thead className="text-center align-middle">
              <tr>
                <th style={{ width: "4%", cursor: "pointer" }} onClick={() => handleSort("id")}>
                  ID{" "}
                  {sortConfig.key === "id" && (
                    <span style={{ fontSize: "10px", opacity: 0.6 }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
                  )}
                </th>
                <th style={{ width: "16%", cursor: "pointer" }} onClick={() => handleSort("cliente")}>
                  CLIENTE{" "}
                  {sortConfig.key === "cliente" && (
                    <span style={{ fontSize: "10px", opacity: 0.6 }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
                  )}
                </th>
                <th style={{ width: "12%", cursor: "pointer" }} onClick={() => handleSort("campana")}>
                  CAMPAÑA{" "}
                  {sortConfig.key === "campana" && (
                    <span style={{ fontSize: "10px", opacity: 0.6 }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
                  )}
                </th>
                <th style={{ width: "6%", cursor: "pointer" }} onClick={() => handleSort("cierre")}>
                  CIERRE{" "}
                  {sortConfig.key === "cierre" && (
                    <span style={{ fontSize: "10px", opacity: 0.6 }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
                  )}
                </th>
                <th style={{ width: "10%", cursor: "pointer" }} onClick={() => handleSort("factura")}>
                  FACTURA{" "}
                  {sortConfig.key === "factura" && (
                    <span style={{ fontSize: "10px", opacity: 0.6 }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
                  )}
                </th>
                <th style={{ width: "8%", cursor: "pointer" }} onClick={() => handleSort("ticket")}>
                  TICKET{" "}
                  {sortConfig.key === "ticket" && (
                    <span style={{ fontSize: "10px", opacity: 0.6 }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
                  )}
                </th>
                <th style={{ width: "6%", cursor: "pointer" }} onClick={() => handleSort("status")}>
                  STATUS{" "}
                  {sortConfig.key === "status" && (
                    <span style={{ fontSize: "10px", opacity: 0.6 }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
                  )}
                </th>
                {/* <th style={{ width: "5%" }}>TIPO</th>
                <th style={{ width: "6%" }}>QUOTE</th> */}
                <th style={{ width: "13%" }}>INTERMEDIARIO</th>
                <th style={{ width: "7%", cursor: "pointer" }} onClick={() => handleSort("ejecutivo")}>
                  EJECUTIVO{" "}
                  {sortConfig.key === "ejecutivo" && (
                    <span style={{ fontSize: "10px", opacity: 0.6 }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
                  )}
                </th>
                <th colSpan="3" style={{ width: "6%" }}>
                  ACCIONES
                </th>
              </tr>
            </thead>
            <tbody className="table-striped" style={{ height: "35px", lineHeight: "35px" }}>
              {sortedOportunidades.length === 0 ? (
                <tr>
                  <td colSpan="15" className="text-center">
                    No hay ventas ni oportunidades según los filtros seleccionados :(
                  </td>
                </tr>
              ) : (
                sortedOportunidades.map((oportunidad) => (
                  <tr
                    key={`${oportunidad.type || "regular"}-${oportunidad.id}`}
                    style={{ height: "35px", lineHeight: "35px" }}
                  >
                    <td className="text-center align-middle">
                      {oportunidad.type === "contrato" && oportunidad.display_id
                        ? oportunidad.display_id
                        : oportunidad.id}
                    </td>
                    <td className="text-start align-middle">{oportunidad.cliente}</td>
                    <td className="text-start align-middle">
                      {(oportunidad.campana
                        ? oportunidad.campana.length > 18
                          ? oportunidad.campana.slice(0, 18) + "..."
                          : oportunidad.campana
                        : "-"
                      ).toUpperCase()}
                    </td>
                    <td className="text-center align-middle">
                      {oportunidad.mes_cierre &&
                      typeof oportunidad.mes_cierre === "string" &&
                      /^\d{2}-\d{4}$/.test(oportunidad.mes_cierre)
                        ? `${mesEnLetras(oportunidad.mes_cierre.split("-")[0])}/${oportunidad.mes_cierre
                            .split("-")[1]
                            .slice(-2)}`
                        : "-"}
                    </td>
                    <td className="text-center align-middle">
                      {oportunidad.type === "contrato" ? (
                        <span>
                          {oportunidad.mes_inicio && mesEnLetras(oportunidad.mes_inicio.split("-")[0])}/
                          {oportunidad.mes_inicio?.split("-")[1]?.slice(-2)}
                          {" → "}
                          {oportunidad.mes_fin && mesEnLetras(oportunidad.mes_fin.split("-")[0])}/
                          {oportunidad.mes_fin?.split("-")[1]?.slice(-2)}
                        </span>
                      ) : oportunidad.facturafecha ? (
                        `${new Date(oportunidad.facturafecha)
                          .toLocaleString(localString(pais), { month: "short" })
                          .replace(/\.$/, "")
                          .toUpperCase()}/${new Date(oportunidad.facturafecha).getFullYear().toString().slice(-2)}`
                      ) : oportunidad.mes_factura &&
                        typeof oportunidad.mes_factura === "string" &&
                        /^\d{2}-\d{4}$/.test(oportunidad.mes_factura) ? (
                        `${mesEnLetras(oportunidad.mes_factura.split("-")[0])}/${oportunidad.mes_factura
                          .split("-")[1]
                          .slice(-2)}`
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="text-end align-middle">
                      {moneda(pais)}{" "}
                      {(oportunidad.type === "btl"
                        ? getConvertedImporteBTL(oportunidad, rate)
                        : getConvertedImporte(oportunidad, rate)
                      ).toLocaleString(localString(pais), {
                        maximumFractionDigits: decimales(pais),
                        minimumFractionDigits: decimales(pais),
                      })}
                    </td>
                    <td
                      className={`text-center align-middle ${
                        oportunidad.estatus === "100%"
                          ? "bg-success text-white"
                          : oportunidad.estatus === "90%"
                            ? "bg-danger text-white"
                            : oportunidad.estatus === "75%"
                              ? "bg-primary text-white"
                              : oportunidad.estatus === "50%"
                                ? "bg-warning text-dark"
                                : "bg-black text-white"
                      }`}
                    >
                      {oportunidad.estatus}
                    </td>
                    {/* <td className="text-center align-middle">
                      {oportunidad.type === "btl" ? (
                        "BTL"
                      ) : oportunidad.type === "contrato" ? (
                        <span>
                          {oportunidad.tipo === "p" ? "P" : "D"}
                          <span
                            className="badge bg-info text-white ms-1"
                            style={{ fontSize: "0.6rem", verticalAlign: "middle" }}
                          >
                            {oportunidad.meses_actividad}M
                          </span>
                          {oportunidad.personas_comprometidas && (
                            <span
                              className="badge bg-warning text-dark ms-1"
                              style={{ fontSize: "0.6rem", verticalAlign: "middle" }}
                            >
                              AR
                            </span>
                          )}
                        </span>
                      ) : oportunidad.tipo === null || oportunidad.tipo === "d" ? (
                        "D"
                      ) : oportunidad.tipo === "p" ? (
                        "P"
                      ) : oportunidad.tipo === "m" ? (
                        "M"
                      ) : (
                        oportunidad.tipo || "-"
                      )}
                    </td> */}
                    {/* <td className="text-center align-middle">
                      {oportunidad.formatopauta === "A"
                        ? "5"
                        : oportunidad.formatopauta === "B"
                          ? "10"
                          : oportunidad.formatopauta === "C"
                            ? "20"
                            : oportunidad.formatopauta}
                    </td>
                    <td className="text-center align-middle">{oportunidad.periodopauta}</td> */}
                    {/* <td className="text-center align-middle">
                      {oportunidad.code && oportunidad.code !== "-" ? (
                        <span
                          style={{ cursor: "pointer", color: "#007bff" }}
                          onClick={() => handleShowDetails(oportunidad)}
                        >
                          {oportunidad.code}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td> */}
                    <td className="text-center align-middle">
                      {oportunidad.type === "btl"
                        ? "EDIFICIOS"
                        : (() => {
                            const clientIntermediary = clienteIntermediarioMap[oportunidad.client_id];
                            return clientIntermediary && intermediaryMap[clientIntermediary]
                              ? intermediaryMap[clientIntermediary]
                              : "-";
                          })()}
                    </td>
                    <td className="text-center align-middle">{oportunidad.ejecutivo}</td>
                    <td className="text-center align-middle">
                      {(() => {
                        const condition =
                          oportunidad.type === "btl" ||
                          (pais === "Chile" &&
                            (oportunidad.facturanumero ||
                              oportunidad.estatus === "0%" ||
                              id.toString() !== String(oportunidad.ejecutivoId || ""))) ||
                          (!["Chile"].includes(pais) && (oportunidad.facturanumero || oportunidad.estatus === "0%"));
                        return condition ? "-" : <TiFlash onClick={() => handleFlashEdit(oportunidad)} />;
                      })()}
                    </td>
                    <td className="text-center align-middle">
                      {(() => {
                        const condition =
                          oportunidad.type === "btl" ||
                          oportunidad.type === "contrato" ||
                          (pais === "Chile" &&
                            (oportunidad.facturanumero ||
                              oportunidad.estatus === "0%" ||
                              id.toString() !== String(oportunidad.ejecutivoId || ""))) ||
                          (!["Chile"].includes(pais) && (oportunidad.facturanumero || oportunidad.estatus === "0%"));
                        return condition ? "-" : <FaEdit onClick={() => handleEdit(oportunidad)} />;
                      })()}
                    </td>
                    <td className="text-center align-middle">
                      {(() => {
                        const commonConditions = oportunidad.facturanumero || oportunidad.estatus === "0%";
                        const userMatchCondition = id.toString() !== String(oportunidad.ejecutivoId || "");
                        if (pais === "Chile") {
                          if (commonConditions || userMatchCondition) {
                            return "-";
                          }
                        } else if (commonConditions) {
                          return "-";
                        }
                        return (
                          <FaTrash
                            onClick={() =>
                              handleConfirmationModal({
                                id: oportunidad.type === "btl" ? oportunidad.full_id : oportunidad.id,
                                type: oportunidad.type,
                              })
                            }
                          />
                        );
                      })()}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Modal isOpen={isEditing} toggle={() => setIsEditing(false)} size="xl">
        <ModalHeader>Editar Oportunidad #{editingOpportunity?.id || "Cargando..."}</ModalHeader>
        <ModalBody>
          {editingOpportunity ? (
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(onSubmitEdit)}>
                <div className="row g-3">
                  <div className="col-4">
                    <label htmlFor="estatus" className="form-label">
                      Estatus
                    </label>
                    <select
                      className={`form-control ${errors.estatus ? "is-invalid" : ""}`}
                      id="estatus"
                      {...register("estatus", { required: true })}
                    >
                      <option value="">Selecciona un porcentaje</option>
                      <option value="100%">100%</option>
                      <option value="90%">90%</option>
                      <option value="75%">75%</option>
                      <option value="50%">50%</option>
                      <option value="0%">0%</option>
                    </select>
                    {errors.estatus && <div className="invalid-feedback">Este campo es obligatorio</div>}
                  </div>
                  <div className="col-4">
                    <label htmlFor="mes_cierre" className="form-label">
                      Mes de Cierre
                    </label>
                    <select
                      className={`form-control ${errors.mes_cierre ? "is-invalid" : ""}`}
                      id="flash_mes_cierre"
                      {...register("mes_cierre", { required: true })}
                    >
                      {months.map((month) => (
                        <option key={month.value} value={month.value}>
                          {month.label}
                        </option>
                      ))}
                    </select>
                    {errors.mes_cierre && <div className="invalid-feedback">Este campo es obligatorio</div>}
                  </div>
                  <div className="col-4">
                    <label htmlFor="mes" className="form-label">
                      Mes Facturación
                    </label>
                    <select
                      className={`form-control ${errors.mes ? "is-invalid" : ""}`}
                      id="mes"
                      {...register("mes", { required: true })}
                      defaultValue={editingOpportunity?.mes || "01"}
                    >
                      {months.map((month) => (
                        <option key={month.value} value={month.value}>
                          {month.label}
                        </option>
                      ))}
                    </select>
                    {errors.mes && <div className="invalid-feedback">Este campo es obligatorio</div>}
                  </div>
                </div>
              </form>
            </FormProvider>
          ) : (
            <p>Cargando...</p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setIsEditing(false)} disabled={loading}>
            Cancelar
          </Button>
          <Button color="primary" onClick={handleSubmit(onSubmitEdit)} disabled={loading}>
            {loading ? "Guardando..." : "Guardar"}
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={showConfirmationModal} toggle={() => setShowConfirmationModal(false)}>
        <ModalHeader>Confirmación</ModalHeader>
        <ModalBody>¿Está seguro de eliminar esta oportunidad?</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowConfirmationModal(false)}>
            Cancelar
          </Button>
          <Button color="primary" onClick={() => handleDelete(deletedOpportunity.id, deletedOpportunity.type)}>
            Eliminar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={showDetailsModal} toggle={() => setShowDetailsModal(false)} size="xl">
        <ModalHeader toggle={() => setShowDetailsModal(false)} style={{ padding: "10px 15px" }}>
          <div className="d-flex align-items-center w-100">
            <div>
              <span>Detalles de la cotización #{selectedOpportunity?.code}</span>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          {selectedOpportunity ? (
            <div className="details-container">
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <strong>Ejecutivo:</strong>{" "}
                    {users.find((user) => user.id.toString() === selectedOpportunity.ejecutivo.toString())?.nombre ||
                      selectedOpportunity.ejecutivo}
                  </p>
                  <p>
                    <strong>Cliente:</strong> {selectedOpportunity.cliente}
                  </p>
                  <p>
                    <strong>Importe:</strong> {moneda(pais)}{" "}
                    {(selectedOpportunity.type === "btl"
                      ? getConvertedImporteBTL(selectedOpportunity, rate)
                      : getConvertedImporte(selectedOpportunity, rate)
                    ).toLocaleString(localString(pais), {
                      maximumFractionDigits: decimales(pais),
                      minimumFractionDigits: decimales(pais),
                    })}
                  </p>
                  <p>
                    <strong>Mes de Cierre:</strong>{" "}
                    {selectedOpportunity.mes_cierre ? mesEnLetras(selectedOpportunity.mes_cierre.split("-")[0]) : "-"}
                  </p>
                  <p>
                    <strong>Mes Facturación:</strong>{" "}
                    {selectedOpportunity.mes_factura ? mesEnLetras(selectedOpportunity.mes_factura.split("-")[0]) : "-"}
                  </p>
                  <p>
                    <strong>Intermediario:</strong>{" "}
                    {intermediaryMap[selectedOpportunity.intermediario] || selectedOpportunity.intermediario || "-"}
                  </p>
                  <p>
                    <strong>Frecuencia:</strong>{" "}
                    {selectedOpportunity.formatopauta === "A"
                      ? "5"
                      : selectedOpportunity.formatopauta === "B"
                        ? "10"
                        : selectedOpportunity.formatopauta === "C"
                          ? "20"
                          : selectedOpportunity.formatopauta}
                  </p>
                  <p>
                    <strong>Días:</strong> {selectedOpportunity.periodopauta}
                  </p>
                  <p>
                    <strong>Tipo:</strong>{" "}
                    {selectedOpportunity.tipo === null || selectedOpportunity.tipo === "d"
                      ? "D"
                      : selectedOpportunity.tipo === "p"
                        ? "P"
                        : selectedOpportunity.tipo === "m"
                          ? "M"
                          : selectedOpportunity.tipo || "-"}
                  </p>
                  <p>
                    <strong>Pantallas Totales:</strong> {selectedOpportunity.pantallastotales}
                  </p>
                  <p>
                    <strong>Edificios Totales:</strong> {selectedOpportunity.edificiostotales}
                  </p>
                  <div>
                    <strong
                      onClick={toggleBuildingsList}
                      style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                    >
                      Edificios participantes{" "}
                      <span style={{ marginLeft: "5px" }}>{isBuildingsExpanded ? "▼" : "▶"}</span>
                    </strong>
                    <Collapse isOpen={isBuildingsExpanded}>
                      <ul>
                        {selectedOpportunity?.edificiosparticipantes?.length > 0 && edificios.length > 0 ? (
                          [...new Set(selectedOpportunity.edificiosparticipantes.split(","))].map((id, index) => {
                            const edificio = edificios.find((ed) => ed.id.toString() === id.trim());
                            return edificio ? (
                              <li key={`${id}-${index}`}>{edificio.edificio}</li>
                            ) : (
                              <li key={`${id}-${index}`}>Edificio ID {id} (desconocido)</li>
                            );
                          })
                        ) : edificios.length === 0 ? (
                          <li>No se pudieron cargar los edificios</li>
                        ) : (
                          <li>-</li>
                        )}
                      </ul>
                    </Collapse>
                  </div>
                </div>
              </div>
              {selectedOpportunity.facturanumero && (
                <div className="mt-3">
                  <h6>Información de Facturación</h6>
                  <p>
                    <strong>Número de Factura:</strong> {selectedOpportunity.facturanumero}
                  </p>
                  <p>
                    <strong>Fecha de Factura:</strong>{" "}
                    {new Date(selectedOpportunity.facturafecha).toLocaleDateString(localString(pais))}
                  </p>
                  <p>
                    <strong>Fecha de Cobro:</strong>{" "}
                    {selectedOpportunity.facturafechacobro
                      ? new Date(selectedOpportunity.facturafechacobro).toLocaleDateString(localString(pais))
                      : "-"}
                  </p>
                </div>
              )}
            </div>
          ) : (
            <p>Cargando...</p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowDetailsModal(false)}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={isFlashEditing} toggle={() => setIsFlashEditing(false)} size="lg">
        <ModalHeader>
          Edición FLASH #{flashEditingOpportunity?.id || "Cargando..."}
          {flashEditingOpportunity && (
            <span className="ms-2">
              - {clientes.find((c) => c.id === flashEditingOpportunity.client_id)?.empresa || ""}
            </span>
          )}
        </ModalHeader>
        <ModalBody>
          {flashEditingOpportunity ? (
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(onSubmitFlashEdit)}>
                <div className="row g-3">
                  <div className="col-12">
                    <label htmlFor="flash_estatus" className="form-label">
                      Estatus
                    </label>
                    <select
                      className={`form-control ${errors.estatus ? "is-invalid" : ""}`}
                      id="flash_estatus"
                      {...register("estatus", { required: true })}
                    >
                      <option value="">Selecciona un porcentaje</option>
                      <option value="100%">100%</option>
                      <option value="90%">90%</option>
                      <option value="75%">75%</option>
                      <option value="50%">50%</option>
                      <option value="0%">0%</option>
                    </select>
                    {errors.estatus && <div className="invalid-feedback">Este campo es obligatorio</div>}
                  </div>
                  <div className="col-6">
                    <label htmlFor="flash_mes_cierre" className="form-label">
                      Mes de Cierre
                    </label>
                    <select
                      className={`form-control ${errors.mes_cierre ? "is-invalid" : ""}`}
                      id="flash_mes_cierre"
                      {...register("mes_cierre", { required: true })}
                    >
                      {months.map((month) => (
                        <option key={month.value} value={month.value}>
                          {month.label}
                        </option>
                      ))}
                    </select>
                    {errors.mes_cierre && <div className="invalid-feedback">Este campo es obligatorio</div>}
                  </div>
                  <div className="col-6">
                    <label htmlFor="flash_ano_cierre" className="form-label">
                      Año de Cierre
                    </label>
                    <select
                      className={`form-control ${errors.ano_cierre ? "is-invalid" : ""}`}
                      id="flash_ano_cierre"
                      {...register("ano_cierre", { required: true })}
                    >
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                      <option value="2027">2027</option>
                    </select>
                    {errors.ano_cierre && <div className="invalid-feedback">Este campo es obligatorio</div>}
                  </div>
                  {flashEditingOpportunity?.type !== "contrato" && (
                    <>
                      <div className="col-6">
                        <label htmlFor="flash_mes_factura" className="form-label">
                          Mes Facturación
                        </label>
                        <select
                          className={`form-control ${errors.mes_factura ? "is-invalid" : ""}`}
                          id="flash_mes_factura"
                          {...register("mes_factura", { required: flashEditingOpportunity?.type !== "contrato" })}
                        >
                          {months.map((month) => (
                            <option key={month.value} value={month.value}>
                              {month.label}
                            </option>
                          ))}
                        </select>
                        {errors.mes_factura && <div className="invalid-feedback">Este campo es obligatorio</div>}
                      </div>
                      <div className="col-6">
                        <label htmlFor="flash_ano_factura" className="form-label">
                          Año Facturación
                        </label>
                        <select
                          className={`form-control ${errors.ano_factura ? "is-invalid" : ""}`}
                          id="flash_ano_factura"
                          {...register("ano_factura", { required: flashEditingOpportunity?.type !== "contrato" })}
                        >
                          <option value="2025">2025</option>
                          <option value="2026">2026</option>
                          <option value="2027">2027</option>
                        </select>
                        {errors.ano_factura && <div className="invalid-feedback">Este campo es obligatorio</div>}
                      </div>
                    </>
                  )}
                </div>
              </form>
            </FormProvider>
          ) : (
            <p>Cargando...</p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setIsFlashEditing(false)} disabled={loading}>
            Cancelar
          </Button>
          <Button color="primary" onClick={handleSubmit(onSubmitFlashEdit)} disabled={loading}>
            {loading ? "Guardando..." : "Guardar"}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};
